<template>
  <div class="wrapper">
    <Sidebar :class="!isOpenSidebar ? 'close-sidebar': ''" />
    <div id="wrapper-content" :class="!isOpenSidebar ? 'ml-0' : 'content-wrapper-margin'">
      <PageHeader :isListPage="true" @toggleSidebar="toggleSidebar" />
      <div class="dashboard-wrapper">
        <div class="content-top-bar mb-3">
          <div class="row align-items-center">
            <div class="col-sm-3 col-md-6 ">
              <!-- <h5>Sites</h5> -->
              <input v-model="searchText" type="text" class="text-input search-site-text" placeholder="Search Global components by Title">
            </div><!-- 6 -->
            <div class="col-sm-9 col-md-6 text-right flex items-center justify-end">
              <input v-model="newCompName" type="text" placeholder="Component name" class="text-input mr-2" style="max-width:220px;" />
              <a @click.prevent="createGlobalComponent" href="#" class="btn btn-default btn-black">Create Global Component</a>
            </div>
          </div><!-- row -->
        </div><!-- content-top-bar -->

        <div class="bg-white px-3 py-2 rounded-sm">
          <div v-for="comp of components" :key="comp._id" class="w-full px-2 py-3 border-b mr-2 flex items-center">
            <div class="text-xs w-52">
              {{ comp._id}}
            </div>
            <label>{{ comp.name }}</label>
            <div class="flex gap-3 ml-auto">
              <a :href="`/comp-edit/${comp._id}`" class="pointer action-btn">
                <i class="fa-solid fa-pen-to-square"></i>
              </a>
              <button class="pointer action-btn">
                <i class="fa-solid fa-box-archive"></i>
              </button>
            </div>
          </div>
  
          <div class="ml-auto mt-4 mr-5 flex items-center">
            <div
              v-if="currentPage - 1 > 0"
              @click="currentPage --"
              class="cursor-pointer"
            >&lt;</div>
            <div
              v-for="page of pages"
              :key="page"
              @click="currentPage = page"
              class="mx-2 cursor-pointer"
              :class="page === this.currentPage ? 'font-bold': ''"
            >
              {{ page + 1 }}
            </div>
            <div
              v-if="currentPage + 1 < Math.ceil(this.total / this.perPage)"
              @click="currentPage ++"
              class="cursor-pointer"
            >&gt;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as compService from '../service/component'
import PageHeader from './components/PageHeader'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: "GlobalComponents",
  components: {
    PageHeader,
    Sidebar,
  },
  data() {
    return {
      searchText: '',
      loading: false,
      isOpenSidebar: true,
      newCompName: '',
      currentPage: 0,
      perPage: 20,
      total: 0,
      components: []
    }
  },
  watch: {
    currentPage () {
      this.loadData()
    }
  },
  computed: {
    pages () {
      const numPages = Math.ceil(this.total / this.perPage)
      const pages = [-2, -1, 0, 1, 2].map(delta => this.currentPage + delta)
        .filter(page => page >=0 && page < numPages)
      return pages
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.loading = true
      const res = await compService.getGlobalComponents(this.currentPage, this.perPage)
      this.components = res.components
      this.total = res.count
      this.loading = false
    },
    async createGlobalComponent() {
      const name = (this.newCompName || '').trim()
      if (!name) {
        this.$notify({ type: 'warn', text: 'Please enter a component name' })
        return
      }
      this.loading = true
      try {
        // Check for existing global components with same name (server-side search)
        const res = await compService.getGlobalComponents(0, 1, name)
        if (res && res.components && res.components.some(c => c.name === name)) {
          this.$notify({ type: 'error', text: 'A global component with that name already exists' })
          return
        }

        await compService.createComponent({
          component: {
            template: `<div>${name} component</div>`,
            name,
            props: [],
            data: [],
            deps: [],
            is_global: true,
          }
        })
        this.newCompName = ''

        // Refresh the list to show the newly created component
        this.currentPage = 0
        await this.loadData()
        this.$notify({ type: 'success', text: 'Global component created' })
      } catch (err) {
        console.log('err creating global component', err)
        this.$notify({ type: 'error', text: 'Error creating global component' })
      } finally {
        this.loading = false
      }
    },
    toggleSidebar() {
      this.isOpenSidebar = !this.isOpenSidebar
    }
  }
}
</script>
